const eventApplicationCreateModel = {
  id: null,
  eventId: "",
  title: "",
  smallDecription: "",
  deadLine: null,
  description: "",
  termsCondition: null,
  initialPaymentPer: null,
  contactName: "",
  email: "",
  phone: "",
  applicationFor: null,
  amount: null,
  payOutDate: null,
  image: "",
  isActive: false,
  applicationType: 0,
  auctionsDays: null,
  auctionStartDate: null,
  requiredDocuments: null,
  secondPaymentInterval:null,
};

export default eventApplicationCreateModel;
